<template>
  <div v-if="show" :class="[store.isMovil ? scrolling : ['top-0', scrolling], route.name != 'Store' && route.name != 'News' && route.name != 'Modal' && route.name != 'ModalT' ? 'h-header-min' : 'h-header']" class="sticky z-30 max-md:menu-mobile max-md:h-fh-mobile">
    <nav class="h-full">
      <NavegationBar />
    </nav>
  </div>

  <main :class="[route.name != 'Store' && route.name != 'News' && route.name != 'Modal' && route.name != 'ModalT' ? ['min-h-struct-body'] : ['min-h-struct-body-special'], store.getIsPP() ? 'pt-0' : 'pt-special']" class="max-md:pt-0 relative py-third max-md:min-h-struct-body-mobile">
    <AlertC />
    <div id="container-sub-filter" v-if="(route.name == 'Store' || route.name == 'News' || route.name == 'Modal' || route.name == 'ModalT')" class="top-header-desktop z-10 w-full pb-min max-md:top-0 max-md:pb-0" :class="[store.isMovil ? ['fixed', ' shadow-white', 'shadow-card-v3', 'dark:shadow-primary-dark-color-2nd', 'bg-white', 'dark:bg-primary-dark-color-2nd'] : ['relative']]">
      <div id="search-bar" class="shadow-card rounded-full shadow-black-12 w-2/3 mx-auto max-md:pt-middle max-md:w-full max-md:rounded-none">
        <searchBar />
      </div>
    </div>
    <RouterView />
  </main>
  <footer class="h-footer relative z-10 shadow-lg-top shadow-black-12 rounded-t-smoth max-md:h-fh-mobile dark:bg-primary-dark-color-3rd">
    <FooterBar />
  </footer>
</template>

<script setup>
import { RouterView } from 'vue-router'
import { ref, watchEffect } from 'vue';

import NavegationBar from './components/structure/NavegationBar.vue';
import FooterBar from './components/structure/FooterBar.vue'
import AlertC from './components/utils/Alert.vue';
import searchBar from './components/subcomponents/SearchBar.vue';

import { generalStore } from '@/stores';

var scrolling = ref('')
var lastScroll = ref(0)
var show = ref(true)

window.addEventListener("scroll", () => {
  const currentScroll = window.scrollY;
  if (currentScroll == 0) {
    scrolling.value = '';
    return;
  }

  if (currentScroll > lastScroll.value) {
    if (store.isMovil) {
      scrolling.value = 'scroll';
    }
  } else if (currentScroll < lastScroll.value) {
    scrolling.value = '';
  }
  lastScroll.value = currentScroll;
})

const store = generalStore();
var route = store.route;

watchEffect(() => {
  if ((route.name == 'ModalT' || route.name == 'Modal') && store.isMovil) {
    show.value = false;
  }

  if ((route.name != 'ModalT' && route.name != 'Modal') && store.isMovil) {
    show.value = true;
  }
})
</script>
